import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import classNames from 'classnames';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { IMenuItem } from '../../../lib/interfaces/MenuItem';

type SidebarMenuListItemProps = {
	item: IMenuItem;
};

const SidebarMenuListItem: FC<SidebarMenuListItemProps> = ({ item }) => {
	const { itemName, icon, navigationLink, slug, isCurrent } = item;
	const navigate = useNavigate();
	const navigateToItem = () => {
		navigate(navigationLink);
	};

	const parentClassNames = classNames({
		TasksSidebarListItem__current: isCurrent,
	});

	return (
		<ListItem
			key={slug}
			disablePadding
			onClick={navigateToItem}
			className={parentClassNames}
		>
			<ListItemButton>
				{icon && (
					<ListItemIcon
						sx={{
							minWidth: '25px',
						}}
					>
						{icon}
					</ListItemIcon>
				)}
				<ListItemText primary={itemName} className="SidebarMenuListItem__text" />
			</ListItemButton>
		</ListItem>
	);
};

export default SidebarMenuListItem;
